import clsx from 'clsx';
import styles from './Card.module.css';

export default function Card({ as: Tag = 'div', padding = 'md', className, children, ...props }) {
  return (
    <Tag className={clsx(styles.card, styles[`p-${padding}`], className)} {...props}>
      {children}
    </Tag>
  );
}
